import React from "react";
import _ from "lodash";
import ModalWrapper from "components/common/ModalWrapper";
import LoadingUI from "components/common/LoadingUI";
import SwitchTabs from "components/common/SwitchTabs";
import HighchartWrapper from "components/common/HighchartWrapper";
import StickyTableWrapper from "components/common/StickyTableWrapper";

class AppliedBaseModal extends React.Component {
  render() {
    const {
      onClose,
      title,
      isLoading,
      errMsg,
      isEmptyData,

      tabOptions,
      selectedTab,

      mainChartOptions,
      mainChartSelected,

      subChartOptions,
      subChartSelected,

      mainChartData,
      subChartData,
      filterData,
      selectedItems,

      handleTabChanged,
      handleMainChartChanged,
      handleSubChartChanged,
      handleImportSelected,

      children,
    } = this.props;

    const parseMainChart =
      selectedTab && mainChartSelected
        ? _.get(mainChartData, [selectedTab, mainChartSelected], {})
        : {};

    const parseSubChart =
      selectedTab && subChartSelected
        ? _.get(subChartData, [selectedTab, subChartSelected], [])
        : [];

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={true}
        handleClose={onClose}
        customOverlayStyle={{ zIndex: 100 }}
        width="70%"
        title={title}
      >
        <div className="overflow-y-auto pr-2" style={{ height: "700px" }}>
          {errMsg && (
            <div className="flex justify-center">
              <div className="text-red-600">{errMsg}</div>
            </div>
          )}
          {isLoading ? (
            <LoadingUI iconOnly={true}></LoadingUI>
          ) : (
            <>
              {isEmptyData && (
                <div className="mt-4 w-full text-center text-gray-600">
                  No data found
                </div>
              )}
              {!_.isEmpty(parseMainChart) && (
                <>
                  <div className="mb-1 flex items-end justify-between">
                    <div className="flex gap-1">
                      {tabOptions.map((option) => (
                        <button
                          disabled={selectedTab === option.value}
                          type="button"
                          className={`rounded mr-1 px-4 py-1 font-semibold text-gray-700 ${
                            selectedTab === option.value
                              ? "bg-blue-200"
                              : "bg-gray-100 hover:bg-gray-200 hover:text-gray-800"
                          }`}
                          onClick={() => handleTabChanged(option)}
                          key={option.value}
                        >
                          {option.label}
                        </button>
                      ))}
                    </div>
                    <div>
                      <SwitchTabs
                        tabs={mainChartOptions}
                        selectedTabKey={mainChartSelected}
                        handleChange={(value) => handleMainChartChanged(value)}
                      ></SwitchTabs>
                    </div>
                  </div>

                  <HighchartWrapper
                    options={parseMainChart}
                    key={`${selectedTab}-${mainChartSelected}`}
                  ></HighchartWrapper>
                  <div className="text-xs text-gray-600">
                    * Drag and select a date range on the chart to zoom in or
                    click on a date label to check details.
                  </div>
                </>
              )}
              {!isEmptyData && (
                <>
                  <div className="mb-1 flex items-end justify-between">
                    <div className="text-xs text-gray-600">
                      {filterData.length} items
                    </div>
                    <button
                      type="button"
                      onClick={handleImportSelected}
                      className={`rounded mb-1 px-6 py-2 font-semibold text-white ${
                        selectedItems.length === 0
                          ? "bg-blue-200"
                          : "shadow bg-blue-400 hover:bg-blue-500"
                      }`}
                      disabled={selectedItems.length === 0}
                    >
                      Import selected
                      {selectedItems.length > 0
                        ? ` (${selectedItems.length})`
                        : ""}
                    </button>
                  </div>
                  <div className="mb-4">
                    <StickyTableWrapper maxHeight="320px" headerRowCount={2}>
                      {children}
                    </StickyTableWrapper>
                  </div>
                </>
              )}
              {!_.isEmpty(parseSubChart) && (
                <>
                  <div className="mb-1 flex items-end justify-end">
                    <div>
                      <SwitchTabs
                        tabs={subChartOptions}
                        selectedTabKey={subChartSelected}
                        handleChange={(value) => handleSubChartChanged(value)}
                      ></SwitchTabs>
                    </div>
                  </div>

                  {parseSubChart
                    .filter((option) => option)
                    .map((option, idx) => (
                      <HighchartWrapper
                        options={option}
                        key={`${selectedTab}-${subChartSelected}-${idx}`}
                      ></HighchartWrapper>
                    ))}
                </>
              )}
            </>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

export default AppliedBaseModal;
